export const renderDay = (dayNames: string, dayNumber: number): string => dayNames.split(' ')[dayNumber];

export const renderMonthYear = (monthNames: string, monthNumber: number, year: number): string => `${monthNames.split(' ')[monthNumber]} ${year}`;
